export default "__VITE_ASSET__BriYDi88__"